import { Map, fromJS } from 'immutable';
import { combineReducers } from 'redux';
import {
  FETCH_QUICK_SEARCH,
  FETCH_QUICK_SEARCH_SUCCESS,
  FETCH_QUICK_SEARCH_FAIL,
  REMOVE_QUICK_SEARCH
} from '../actions/actionTypes';

const transformProductData = payload => {
  const productData = payload.getIn(['products', 'hits'], []);
  const filteredProductData = productData.filter(product => product.get('item') && product.get('relevance'));
  const transformedProductData = filteredProductData.map(product => {
    const object = fromJS({
      id: product.getIn(['item', 'id']),
      relevance: product.get('relevance')
    });

    return object;
  });

  if (productData.length === 0) {
    return payload;
  }

  return payload.setIn(['products', 'hits'], transformedProductData);
};

const initialState = Map();

const results = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_QUICK_SEARCH: {
      return state;
    }
    case FETCH_QUICK_SEARCH_SUCCESS: {
      return transformProductData(payload);
    }
    case FETCH_QUICK_SEARCH_FAIL: {
      return state;
    }
    case REMOVE_QUICK_SEARCH: {
      return initialState;
    }
    default:
      return state;
  }
};

const status = (state = '', { type }) => {
  switch (type) {
    case FETCH_QUICK_SEARCH: {
      return 'LOADING';
    }
    case FETCH_QUICK_SEARCH_SUCCESS: {
      return 'SUCCESS';
    }
    case FETCH_QUICK_SEARCH_FAIL: {
      return 'FAIL';
    }
    case REMOVE_QUICK_SEARCH: {
      return "";
    }
    default:
      return state;
  }
};

const query = (state = '', { type, payload }) => {
  switch (type) {
    case FETCH_QUICK_SEARCH: {
      return payload;
    }
    case REMOVE_QUICK_SEARCH: {
      return null;
    }
    default:
      return state;
  }
};

export default combineReducers({
  results,
  status,
  query
});



// WEBPACK FOOTER //
// ./src/reducers/quickSearch.js